/* =====================================================================
   Owl + Fox — Collection Infinite Scroll  (v3.1)
   Progressive enhancement over the numbered pagination.

   · When JS runs, #coll-v2-page gets `.js-infinite`: the numbered pager
     is hidden (kept in the DOM for no-JS / crawlers) and a cumulative
     "Showing X of Y" line + a "Load more" button take its place.
   · The next page is fetched via the Section Rendering API as the pager
     nears the viewport and its products are appended to the grid.
   · AUTO_CAP pages load automatically; after that the shopper clicks
     "Load more" (one page per click) so the footer stays reachable.
   · The URL is NOT rewritten to ?page=N — reload / Back return cleanly
     to the top of the collection. Deep links to ?page=N still render.
   · Re-initialises after AJAX filter / sort updates replace the results.
   ===================================================================== */
(function () {
  'use strict';

  var SECTION_ID = 'main-collection';
  var AUTO_CAP   = 3;          /* pages auto-appended before "Load more" */

  var loading    = false;
  var done       = false;
  var autoLoads  = 0;          /* auto-appends used since last (re)arm */
  var manualMode = false;      /* true once the cap is hit / user clicked */
  var shown      = 0;          /* cumulative products displayed */
  var observer   = null;

  function page() { return document.getElementById('coll-v2-page'); }

  function nextLink() {
    return document.querySelector('#coll-grid-inner .pg-btn--nav[aria-label="Next page"]');
  }

  function gridItemCount() {
    var grid = document.getElementById('coll-grid');
    if (!grid) return 0;
    return grid.querySelectorAll(':scope > li:not(.coll-v2__empty)').length;
  }

  function wrapData(attr, fallback) {
    var w = document.querySelector('#coll-grid-inner .pg-wrap');
    var v = w ? parseInt(w.getAttribute(attr), 10) : NaN;
    return isNaN(v) ? fallback : v;
  }
  function totalCount() { return wrapData('data-total', 0); }

  function moreBtn()  { return document.querySelector('#coll-grid-inner .pg-more__btn'); }
  function countEl()  { return document.querySelector('#coll-grid-inner .pg-count'); }

  function refreshUI() {
    var total = totalCount();
    var c = countEl();
    if (c) {
      c.textContent = (done && shown >= total && total > 0)
        ? ('Showing all ' + total)
        : ('Showing ' + shown + ' of ' + total);
    }
    var btn = moreBtn();
    if (btn) btn.hidden = !(manualMode && !done);
  }

  function sentinel() {
    var inner = document.getElementById('coll-grid-inner');
    if (!inner) return null;
    var s = document.getElementById('coll-inf-sentinel');
    if (!s) {
      s = document.createElement('div');
      s.id = 'coll-inf-sentinel';
      s.setAttribute('aria-hidden', 'true');
      s.style.cssText = 'height:1px;margin-top:-1px';
      var pager = inner.querySelector('.pg-wrap');
      if (pager) inner.insertBefore(s, pager);
      else inner.appendChild(s);
    }
    return s;
  }

  function sentinelNear() {
    var s = document.getElementById('coll-inf-sentinel');
    if (!s) return false;
    var r = s.getBoundingClientRect();
    return r.top < (window.innerHeight + 600);
  }

  function loadNext(isManual) {
    if (loading || done) return;
    if (!isManual && manualMode) return;

    var link = nextLink();
    if (!link) { done = true; refreshUI(); return; }
    var url = link.getAttribute('href');
    loading = true;

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SECTION_ID;
    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('coll-grid');
        var newGrid = doc.getElementById('coll-grid');
        var oldPager = document.querySelector('#coll-grid-inner .pg-wrap');
        var newPager = doc.querySelector('#coll-grid-inner .pg-wrap');

        if (grid && newGrid) {
          var added = 0;
          while (newGrid.firstElementChild) {
            if (newGrid.firstElementChild.tagName === 'LI') added++;
            grid.appendChild(newGrid.firstElementChild);
          }
          shown += added;
        }
        if (oldPager) {
          if (newPager) oldPager.replaceWith(newPager);
          else { oldPager.remove(); done = true; }
        }

        /* Deliberately NOT touching window.history — infinite scroll
           should not strand the shopper on ?page=N. */

        if (window.ofV3DensityRefresh) window.ofV3DensityRefresh();
        if (!nextLink()) done = true;

        if (!isManual) {
          autoLoads++;
          if (autoLoads >= AUTO_CAP) manualMode = true;
        }
        refreshUI();
      })
      .catch(function () { done = true; refreshUI(); })
      .finally(function () {
        loading = false;
        /* Stall guard: if the sentinel is still in view and we're still
           in auto mode, keep going — IntersectionObserver won't re-fire
           without a fresh intersection change. */
        if (!done && !manualMode && sentinelNear()) loadNext(false);
      });
  }

  function startObserver() {
    var s = sentinel();
    if (!s) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext(false);
    }, { rootMargin: '600px 0px' });
    observer.observe(s);
  }

  function arm() {
    if (!document.getElementById('coll-grid-inner')) return;
    var p = page();
    if (p) p.classList.add('js-infinite');

    loading = false;
    done = !nextLink();
    autoLoads = 0;
    manualMode = false;
    shown = wrapData('data-shown', gridItemCount());

    refreshUI();
    startObserver();
  }

  function init() {
    arm();

    /* One delegated listener for the "Load more" button — survives the
       pager node being swapped out on every append. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.pg-more__btn');
      if (!btn) return;
      e.preventDefault();
      manualMode = true;
      loadNext(true);
    });

    /* AJAX filters / sort replace #coll-results content — re-arm afterwards */
    var results = document.getElementById('coll-results');
    if (results) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length &&
              document.getElementById('coll-grid-inner') &&
              !document.getElementById('coll-inf-sentinel')) {
            arm();
            break;
          }
        }
      }).observe(results, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
